var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInspection = function SvgInspection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 39.789 8.789 121H90z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180 256c0-74.443 60.557-135 135-135 5.136 0 10.01.954 15 1.516V31H120v120H0v330h330v-91.516c-4.99.562-9.864 1.516-15 1.516-74.443 0-135-60.557-135-135M75 457.211l-40.605-40.605 21.211-21.211L75 414.789l49.395-49.395 21.211 21.211zm0-90-40.605-40.605 21.211-21.211L75 324.789l49.395-49.395 21.211 21.211zm0-90-40.605-40.605 21.211-21.211L75 234.789l49.395-49.395 21.211 21.211z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M512 432 398.835 318.624C411.953 301.099 420 279.573 420 256c0-57.99-47.01-105-105-105s-105 47.01-105 105 47.01 105 105 105c23.573 0 45.099-8.047 62.624-21.165l113.165 113.376z"
  })));
};
export default SvgInspection;